<template>
  <div class="exhibitor-info">
    <div class="exhibitor-card">
      <div class="card-banner">
        <img :src="bannerUrl" alt="">
      </div>

      <div class="info">
        <div class="name">{{name}}</div>
        <div class="company-name">{{exhibitorName}}</div>
        <div class="boothNo">{{boothNo}}</div>
      </div>

      <div class="card-bottom">
        <img :src="bottomUrl" alt="">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        bannerUrl: "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/tangjiu/112/exhibitor_card_banner.png?_t=" + Date.now(),
        bottomUrl: "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/tangjiu/112/exhibitor_card_bottom.png?_t=" + Date.now(),
        name: '',
        exhibitorName: '',
        boothNo: ''
      }
    },
    mounted() {
      const { name, exhibitorName, boothNo } = this.$route.query
      this.name = decodeURIComponent(name)
      this.exhibitorName = decodeURIComponent(exhibitorName)
      this.boothNo = decodeURIComponent(boothNo)
    },
  }
</script>

<style lang="scss" scoped>
  .exhibitor-info {
    max-width: 750px;
    min-height: 100vh;
    background: #ffffff;
    overflow-y: scroll;
    .exhibitor-card {
      width: 100%;
      img {
        display: block;
        width: 100%;
      }
      .info {
        margin: auto;
        text-align: center;
        padding: 0 16px;
        box-sizing: border-box;
      }
      .name {
        font-size: 20px;
        font-weight: 700;
      }
      .company-name {
        font-size: 20px;
        font-weight: 700;
        margin-top: 24px;
      }
      .boothNo {
        font-size: 20px;
        font-weight: 700;
        margin-top: 24px;
      }
      .card-bottom {
        margin-top: 100px;
      }
    }
  }
</style>